import type { TabBarControls } from "@-/dev.improve.haniverse.components.ui.floating-tab-bar";
import { DynamicIconsTabBar } from "@-/dev.improve.haniverse.components.ui.floating-tab-bar";

export function MorphemeInfoPanelFloatingTabBar(props: TabBarControls) {
  return <DynamicIconsTabBar {...props} />;
}
